import { apiService } from "@base/configs";
import httpService from "@base/services/httpService";

class CommonService {
  getListShow() {
    return httpService.get(apiService.utils.common.getList);
  }
}

export default new CommonService();
